export const apiUrl = "https://flames02api.WaEPOS.com/";
export const adminUrl = "https://flames02admin.WaEPOS.com/";
